import React from "react";
import { Typography } from "../../index";

const TableHeader = ({
    item,
    colorStyle = "light",
    className
}) => {


    const tableHeaderClasses = [
        `bsw-table-header`,
        `bsw-table-header-color--${colorStyle}`,
        `${className ? className : ''}`
    ].join(' ');

    return (
        <td title={item} className={tableHeaderClasses }>
            <Typography
                tag="div"
                type="body-02"
                bold
                color={colorStyle === 'light' ? '$color-primary-a2' : '$color-primary-c1'}
            >
                {item}
            </Typography>
          
        </td>
    );
};

export default TableHeader;